<div class="card flex justify-content-center" style="width: 100%">
    <p-accordion class="w-full background-249 accordion" [activeIndex]="0" expandIcon="pi pi-chevron-down"
        collapseIcon="pi pi-chevron-up">
        <p-accordionTab iconPos="end">
            <ng-template pTemplate="header">
                <div class="col-1">
                    <img style="padding: unset; margin-left: -1em" src="assets/icons/table/ic64-aimbulance.png"
                        width="64" height="64">
                </div>
                <div class="col-11" style="margin-left: -2em">
                    <span class="white-space-nowrap postavka">
                        Товар {{good.mnnName}}
                    </span>
                    <br>
                    <span class="small-text light">
                        MHH:
                    </span>
                    <span class="small-text">{{good.mnnId}}</span>
                    <span class="small-text light" style="margin-left: 1em">
                        Дозування:
                    </span>
                    <span class="small-text">{{good.dosage}}</span>
                </div>
            </ng-template>
            <div class="grid">
                <div class="col-4">
                    <div class="container">
                        <div class="col-12">
                            <div class="grid">
                                <div class="col-4 column-placement table-item ">
                                    <span class="mobile-h10-text">LOV ID</span>
                                    <span style="word-break: keep-all; white-space: nowrap;"
                                        class="small-text">{{good.lovId}}</span>
                                </div>
                                <div class="col-4 column-placement table-item ">
                                    <span class="mobile-h10-text">МНН ID</span>
                                    <span style="word-break: keep-all; white-space: nowrap;"
                                        class="small-text">{{good.mnnId}}</span>
                                </div>
                                <div class="col-4 column-placement table-item">
                                    <span class="mobile-h10-text">Тип товару</span>
                                    <span style="word-break: keep-all; white-space: nowrap;"
                                        class="small-text">???</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 column-placement table-item">
                            <span class="mobile-h10-text">Напрям</span>
                            <span class="small-text">{{good.direction?.shortName}}</span>
                        </div>
                        <div class="col-12 column-placement table-item sub-direction">
                            <span class="mobile-h10-text">Піднапрям</span>
                            <span class="small-text">{{good.subDirection}}</span>
                        </div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="container">
                        <div class="col-12">
                            <div class="grid">
                                <div class="col-3 column-placement table-item">
                                    <span class="mobile-h10-text">Кількість</span>
                                    <span class="small-text">{{good.quantity}}</span>
                                </div>
                                <div class="col-3 column-placement table-item">
                                    <span class="mobile-h10-text">Вартість
                                        за одиницю, грн</span>
                                    <span class="small-text">{{good.unitPrice}}</span>
                                </div>
                                <div class="col-3 column-placement table-item">
                                    <span class="mobile-h10-text">Загальна
                                        вартість</span>
                                    <span class="small-text">{{good.totalPrice}}</span>
                                </div>
                                <div class="col-3 column-placement table-item">
                                    <span class="mobile-h10-text">Кратність</span>
                                    <span class="small-text">-</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="grid">
                                <div class="col-3 column-placement table-item">
                                    <span class="mobile-h10-text">Доступно до розподілу</span>
                                    <span class="small-text">-</span>
                                </div>
                                <div class="col-3 column-placement table-item">
                                    <span class="mobile-h10-text">Розподілено</span>
                                    <span class="small-text">-</span>
                                </div>
                                <div class="col-3 column-placement table-item">
                                    <span class="mobile-h10-text">Форма випуску</span>
                                    <span class="small-text" table-item>{{good.releaseForm}}</span>
                                </div>
                                <div class="col-3 column-placement table-item">
                                    <span class="mobile-h10-text">Одиниця виміру</span>
                                    <span class="small-text">{{good.unit}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="grid">
                                <div class="col-3 column-placement table-item">
                                    <span class="mobile-h10-text">Серія/Каталожний номер</span>
                                    <span class="small-text">-</span>
                                </div>
                                <div class="col-3 column-placement table-item">
                                    <span class="mobile-h10-text">Дата виробництва</span>
                                    <span class="small-text">-</span>
                                </div>
                                <div class="col-3 column-placement table-item">
                                    <span class="mobile-h10-text">Термін придатності</span>
                                    <span class="small-text">-</span>
                                </div>
                                <div class="col-3 column-placement table-item">
                                    <span class="mobile-h10-text">Номер договору</span>
                                    <span class="small-text">-</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-2">
                    <div class="container">
                        <div class="column-placement col-12 table-item">
                            <span class="mobile-h10-text">Виробник</span>
                            <span class="small-text">Пфайзер</span>
                        </div>
                        <div class="column-placement col-12 table-item">
                            <span class="mobile-h10-text">Країна виробника</span>
                            <span class="small-text">США</span>
                        </div>
                        <div class="column-placement col-12 table-item">
                            <span class="mobile-h10-text">Країна походження</span>
                            <span class="small-text">США</span>
                        </div>
                    </div>
                </div>
            </div>
        </p-accordionTab>

    </p-accordion>
</div>

<p class="page-title">Наявність</p>
<app-loader [hidden]="loadingCounter === 0"></app-loader>

<div class="table-wrapper" [hidden]="loadingCounter > 0">
  <p-table

    #dt2
    styleClass="p-datatable-sm"
    [scrollable]="true"
    scrollHeight="flex"
    [value]="tableBodySpecifications"
    [customSort]="true"
    [lazy]="true"
    [resizableColumns]="true"
    columnResizeMode="expand"
    (onLazyLoad)="loadData()">
    <ng-template pTemplate="header">
      <tr>
        <th><!-- checkbox row--></th>
        <th class="table-header-text" [pSortableColumn]="column.key" *ngFor="let column of filterHeader(tabHeaderSpecifications)" style="background-color: rgb(249, 249, 249)!important; min-width: 10em" pResizableColumn>
          <div style="display: inline-block" class="flex align-items-center" [ngStyle]="{'max-width': ['3', '10', '14', '15', '17', '19', '20', '21'].includes(column.key) ? '15em': 'initial'}" [ngClass]="{'no-wrap': ['3', '10', '14', '15', '17', '19', '20', '21'].includes(column.key)}">
            {{ column.label }}&nbsp;
            <p-sortIcon [field]="column.key" *ngIf="filterActive && filterField === column.key"></p-sortIcon>
            <med-icon-chevron-right [ngStyle]="{'width': '16px', 'cursor': 'pointer'}" *ngIf="'2' === column.key && column.showChevron && !hideGroup1" (click)="showHidedColumns($event, column.key, true)"></med-icon-chevron-right>
            <med-icon-chevron-left [ngStyle]="{'width': '16px', 'cursor': 'pointer'}" *ngIf="'2' === column.key && column.showChevron && hideGroup1" (click)="showHidedColumns($event, column.key, false)"></med-icon-chevron-left>
            <med-icon-chevron-right [ngStyle]="{'width': '16px', 'cursor': 'pointer'}" *ngIf="'17' === column.key && column.showChevron && !hideGroup2" (click)="showHidedColumns($event, column.key, true)"></med-icon-chevron-right>
            <med-icon-chevron-left [ngStyle]="{'width': '16px', 'cursor': 'pointer'}" *ngIf="'17' === column.key && column.showChevron && hideGroup2" (click)="showHidedColumns($event, column.key, false)"></med-icon-chevron-left>
          </div>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-row>
      <tr class="table-content-text">
        <td>
<!--          <med-checkbox size="small"  *ngIf="'MZU' === dataService.userRoleValue.getValue()"-->
<!--                        (change)="onChangeHandlerSpecification(row)"-->
<!--                        [value]="basketService.containsAlreadySpecification(row.specificationId)"-->
<!--                        [disabled]="basketService.hasTheDifferentDirection(row.good.direction.id) || basketService.hasTheDifferentWarehouse(row.warehouseName)"></med-checkbox>-->
        </td>
        <td class="h10-text black-80">
          <div class="flex-12rem">
                        <span class="truncate-text">
                          {{row.good.mnnName}}
                        </span>
          </div>
        </td>
        <td class="h10-text black-60">
          {{row.good.dosage}}
        </td>
        <td class="h10-text black-80 grey-20-background" *ngIf="!hideGroup1">
          {{row.extra.availableForDistribution}}
        </td>
        <td class="h10-text black-80 grey-20-background" *ngIf="!hideGroup1">
          {{row.good.mnnId}}
        </td>
        <td class="h10-text black-80 grey-20-background" *ngIf="!hideGroup1">
          {{row.good.lovId}}
        </td>
        <td class="h10-text black-60 grey-20-background" *ngIf="!hideGroup1">
          <div class="flex-12rem">
                        <span class="truncate-text" [pTooltip]="tooltipDirectionSpec">
                          {{row.good.direction.shortName}}
                        </span>
          </div>
          <ng-template #tooltipDirectionSpec >
            <div class="flex items-center h10-text">
              {{row.good.direction.name}}
            </div>
          </ng-template>

        </td>
        <td class="h10-text black-60 grey-20-background" *ngIf="!hideGroup1">
          {{row.good.unit}}
        </td>
        <td class="h10-text black-80 grey-20-background" *ngIf="!hideGroup1">
          {{row.extra.documents}}
        </td>
        <td class="h10-text black-80 grey-20-background" *ngIf="!hideGroup1">
          {{row.good.subDirection}}
        </td>
        <td>
          <div class="flex-12rem">
                        <span class="truncate-text">
                          {{row.seriesCatalogue}}
                        </span>
          </div>
        </td>
        <td class="h10-text black-80">
          <div class="flex-12rem">
                        <span class="truncate-text">
                          {{row.good.tradeName}}
                        </span>
          </div>
        </td>
        <td class="h10-text black-80">
          {{row.multiplicity}}
        </td>
        <td class="h10-text black-80">
          {{row.quantity}}

        </td>
        <td class="h10-text black-80">
          {{row.adjUnitPrice}}
        </td>
        <td class="h10-text black-80">
          {{getRowSum(row.extra.availableForDistribution, row.adjUnitPrice)}}
        </td>
        <td class="h10-text black-80">
          Номер договору *
        </td>
        <td class="h10-text black-80">
          {{row.dueDate | date: 'dd.MM.yyyy'}}
        </td>
        <td class="h10-text black-80 grey-20-background" *ngIf="!hideGroup2">
          {{row.manufacturer}}
        </td>
        <td class="h10-text black-80 grey-20-background" *ngIf="!hideGroup2">
          {{row.manufacturerCountry}}
        </td>
        <td class="h10-text black-80 grey-20-background" *ngIf="!hideGroup2">
          {{row.originCountry}}
        </td>
        <td class="h10-text black-80 grey-20-background" *ngIf="!hideGroup2">
          {{row.manufactureDate | date: 'dd.MM.yyyy'}}
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="summary">
      <div class="flex flex-center flex-between">
        <med-pagination
          [total]="totalRowsSpecifications"
          [page]="selectedPageNumberSpecifications"
          [perPage]="pageSizeSpecifications"
          (pageChange)="pageChangeSpecifications($event)"
        ></med-pagination>

        <div class="small-text">
          Показано &nbsp;<strong>{{ getFirstShowedRowIndexSpecifications() }}</strong>-<strong>{{ getFirstShowedRowIndexSpecifications() + pageSizeSpecifications }}</strong> &nbsp;з {{ totalRowsSpecifications }}
        </div>

        <div>
          <span class="small-text">Кількість на сторінку</span>
          <med-radio-group
            mode="buttons"
            [value]="totalRowsSpecifications"
            [options]="paginationOptions"
            (onInput)="pageSizeChangedSpecifications($event)"
          ></med-radio-group>
        </div>
      </div>
    </ng-template>
  </p-table>
</div>
